import { FieldState } from "final-form";
import { FormApi } from "final-form";

type INamesAndMetas<TFormInitialValues> = {
  [key in keyof TFormInitialValues]: {
    name: key;
    meta: FieldState<string>;
  };
};

export const getNamesAndMetas = <TFormInitialValues>(
  initialValues: TFormInitialValues,
  form: FormApi<TFormInitialValues>
) => {
  const fieldsName = Object.keys(initialValues) as (keyof TFormInitialValues)[];

  const fieldNamesAndMeta = fieldsName.reduce((acc, fieldName) => {
    return {
      ...acc,
      [fieldName]: {
        name: fieldName,
        meta: form.getFieldState(fieldName),
      },
    };
  }, {});

  return fieldNamesAndMeta as INamesAndMetas<TFormInitialValues>;
};
